import { render } from "./OffersCard.vue?vue&type=template&id=0efbff3d&scoped=true"
import script from "./OffersCard.vue?vue&type=script&lang=js"
export * from "./OffersCard.vue?vue&type=script&lang=js"

import "./OffersCard.vue?vue&type=style&index=0&id=0efbff3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efbff3d"]])

export default __exports__